import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { passwordMatchValidator } from 'src/app/validators/confirm-password.validator';
import { ReCaptchaService } from '../../../services/recaptcha.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private auth: AuthService,
        private router: Router,
        private title: Title,
        public loading: LoadingService,
        private toastr: ToastrService,
        private reCaptchaService: ReCaptchaService,
        private el: ElementRef) {
        this.route.params.subscribe(e => {
            this.key = e.key;
        });
    }
    key: any;
    showNotification = false;
    loginForm = new FormGroup({
        password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
        password_confirmation: new FormControl(null),
    }, { validators: passwordMatchValidator });
    showPassword = false;

    async submitForm(loginForm: any): Promise<void> {
        if (!loginForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0].focus();
            return;
        }

        this.loading.start();
        loginForm.disable({ emitEvent: false });

        try {

            const fdata = this.loginForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('fe_reset_password');
            const res: any = await this.auth.resetPassword({ password: fdata.password, password_confirmation: fdata.password_confirmation, key: this.key, token });

            loginForm.enable({ emitEvent: false });

            if (res.success) {
                this.showNotification = true;
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    loginForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });
                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });

                return;
            }

            const title = res.response?.message || res.response?.description || 'Oops';
            const desc = res.response?.description || 'Error';
            this.toastr.error(desc, title);

        } catch (error) {
            loginForm.enable({ emitEvent: false });
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');
        } finally {
            this.loading.done();
        }
    }

    closeNotification(): void {
        this.router.navigate(['/login']);
    }

    ngOnInit(): void {
        this.title.setTitle('Reset Password | MFGM');
    }
}


